import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BiographyTextarea = ({ value, onChange, error, maxLength = 1000 }) => {
  const [isFocused, setIsFocused] = useState(false);
  const currentLength = value ? value?.length : 0;
  const remainingChars = maxLength - currentLength;

  const handleChange = (e) => {
    const newValue = e?.target?.value;
    if (newValue?.length <= maxLength) {
      onChange(newValue);
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-foreground">
        بیوگرافی و اعتبارات حرفه‌ای
      </label>
      
      <div className="relative">
        <textarea
          value={value || ''}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder="درباره تجربه حرفه‌ای، تحصیلات، گواهینامه‌ها و دستاوردهای خود بنویسید..."
          className={`w-full px-3 py-3 border rounded-md bg-input text-foreground placeholder-muted-foreground resize-none transition-smooth focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${
            error 
              ? 'border-destructive focus:border-destructive focus:ring-destructive' :'border-border focus:border-ring'
          }`}
          rows={6}
          dir="rtl"
        />
        
        {/* Character Counter */}
        <div className="absolute bottom-3 left-3 flex items-center space-x-reverse space-x-2">
          <span className={`text-xs ${
            remainingChars < 50 
              ? 'text-warning' 
              : remainingChars < 0 
                ? 'text-destructive' :'text-muted-foreground'
          }`}>
            {currentLength}/{maxLength}
          </span>
          
          {isFocused && (
            <Icon 
              name="Type" 
              size={14} 
              className="text-muted-foreground" 
            />
          )}
        </div>
      </div>

      <div className="text-xs text-muted-foreground space-y-1">
        <p>• تحصیلات و مدارک دانشگاهی</p>
        <p>• سوابق کاری و پروژه‌های مهم</p>
        <p>• گواهینامه‌ها و افتخارات حرفه‌ای</p>
        <p>• عضویت در نظام‌های حقوقی</p>
      </div>

      {/* Error Message */}
      {error && (
        <p className="text-sm text-destructive flex items-center">
          <Icon name="AlertCircle" size={16} className="ml-2" />
          {error}
        </p>
      )}
    </div>
  );
};

export default BiographyTextarea;